'use strict';

exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _index = require('./index');

var _index2 = _interopRequireDefault(_index);

var _ronUuid = require('@swarm/ron-uuid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Batch = function () {
  function Batch() {
    _classCallCheck(this, Batch);

    for (var _len = arguments.length, frames = Array(_len), _key = 0; _key < _len; _key++) {
      frames[_key] = arguments[_key];
    }

    this.frames = frames;
    this.index = 0;
    return this;
  }

  /*:: @@iterator(): Iterator<Frame> { return ({}: any); } */

  // $FlowFixMe - computed property


  Batch.prototype[Symbol.iterator] = function () {
    this.index = 0;
    return this;
  };

  Batch.prototype.clone = function clone() {
    return new (Function.prototype.bind.apply(Batch, [null].concat([].concat(_toConsumableArray(this.frames)))))();
  };

  Batch.prototype.push = function push(f) {
    this.frames.push(f);
    return this;
  };

  Batch.prototype.next = function next() {
    if (this.frames.length > this.index) {
      return {
        done: false,
        value: this.frames[this.index++]
      };
    }
    return { done: true };
  };

  Batch.prototype.toString = function toString() {
    var ret = [];
    for (var _iterator = this.frames, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var c = _ref;

      ret.push(c.toString());
    }
    return ret.join('\n');
  };

  Batch.prototype.isEmpty = function isEmpty() {
    return !!this.frames.length;
  };

  Batch.prototype.hasFullState = function hasFullState() {
    for (var _iterator2 = this.frames, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var f = _ref2;

      if (f.isFullState()) return true;
      break;
    }
    return false;
  };

  Batch.prototype.equal = function equal(other) {
    if (this.long !== other.long) {
      return false;
    }

    for (var i = 0; i < this.length; i++) {
      if (!this.frames[i].equal(other.frames[i])) {
        return false;
      }
    }

    return true;
  };

  Batch.prototype.sort = function sort(compare) {
    this.frames.sort(compare || function (a, b) {
      var aop = _index2.default.fromString(a.body);
      var bop = _index2.default.fromString(b.body);
      if (aop && bop) return aop.uuid(2).compare(bop.uuid(2));
      throw new Error('unable to compare invalid frames');
    });
    return this;
  };

  Batch.prototype.reverse = function reverse() {
    this.frames.reverse();
    return this;
  };

  Batch.prototype.filter = function filter(f) {
    return new (Function.prototype.bind.apply(Batch, [null].concat(_toConsumableArray(this.frames.filter(f)))))();
  };

  Batch.fromStringArray = function fromStringArray() {
    for (var _len2 = arguments.length, input = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      input[_key2] = arguments[_key2];
    }

    return new (Function.prototype.bind.apply(Batch, [null].concat(_toConsumableArray(input.map(function (i) {
      return new _index.Frame(i);
    })))))();
  };

  Batch.splitByID = function splitByID(source) {
    var b = new Batch();
    var id = _ronUuid.ZERO;
    var c = new _index.Frame();

    for (var _iterator3 = new _index.Frame(source), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray3) {
        if (_i3 >= _iterator3.length) break;
        _ref3 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) break;
        _ref3 = _i3.value;
      }

      var op = _ref3;

      if (op.uuid(1).eq(id)) {
        c.push(op);
      } else {
        if (!id.eq(_ronUuid.ZERO)) {
          b.push(c);
        }
        id = op.uuid(1);
        c = new _index.Frame();
        c.push(op);
      }
    }
    b.push(c);
    return b;
  };

  _createClass(Batch, [{
    key: 'length',
    get: function get() {
      return this.frames.length;
    }
  }, {
    key: 'long',
    get: function get() {
      var ret = 0;
      for (var _iterator4 = this.frames, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
        var _ref4;

        if (_isArray4) {
          if (_i4 >= _iterator4.length) break;
          _ref4 = _iterator4[_i4++];
        } else {
          _i4 = _iterator4.next();
          if (_i4.done) break;
          _ref4 = _i4.value;
        }

        var c = _ref4;

        ret += c.body.length;
      }
      return ret;
    }
  }]);

  return Batch;
}();

exports.default = Batch;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@swarm/ron/lib/batch.js
// module id = 70
// module chunks = 0